import { RESET_ALL_REDUCERS, UPDATE_SOURCE } from 'actions';
import { apiSlice } from 'api/apiSlice';
import { reauthenticateStatusAPI } from 'api/reAuthenticate';
import { navigate } from 'app/navigation';
import { setSessionId, setSessionStatus } from 'features/reauthenticate/state/slice';
import { createPollingActions, getPollingState } from 'redux-polling';

export const updateReauthenticateSessionID = (sessionID, redirect, source) => (dispatch) => {
    dispatch({ type: RESET_ALL_REDUCERS });
    // Clear the RTK Query cache too — RESET_ALL_REDUCERS only resets the plain
    // reducers, not the apiSlice cache.
    dispatch(apiSlice.util.resetApiState());
    dispatch(setSessionId(sessionID));
    source && dispatch({ type: UPDATE_SOURCE, data: { source } });
    sessionID &&
        reauthenticateStatusAPI(sessionID)
            .then((response) => dispatch(setSessionStatus(response.data)))
            .catch(() => navigate('/session-expired?session=expired', { replace: true }));
    navigate(redirect, { replace: true });
};

// Polling of reauthenticate session status API 👇

export const getReauthenticateSessionStatus = (sessionID) => (dispatch) => {
    return reauthenticateStatusAPI(sessionID).then(() => {
        dispatch(actions.reset());
        dispatch(actions.start(sessionID));
    });
};

// Actions

const pollingInterval = 5000;
const historyLength = 1;

export const actions = createPollingActions(
    'reauthenticate-status',
    (sessionID) => reauthenticateStatusAPI(sessionID),
    pollingInterval,
    historyLength
);

// Selectors

const isPollingActive = (state) => getPollingState(state, 'reauthenticate-status').isActive;
const getPointHistory = (state) => getPollingState(state, 'reauthenticate-status').history;
const getLastPoint = (state) => getPollingState(state, 'reauthenticate-status').lastEntry;
const getCount = (state) => getPollingState(state, 'reauthenticate-status').count;

export const selectors = {
    isPollingActive,
    getPointHistory,
    getLastPoint,
    getCount,
};
